import * as React from 'react';
import ReactDOM from 'react-dom';
import { styled } from '@volkswagen-onehub/components-core';
function isReact(renderable) {
    return typeof renderable !== 'function';
}
const StyledLayerWrapper = styled.div `
  &:focus {
    outline: none;
  }
`;
StyledLayerWrapper.displayName = 'StyledLayerWrapper';
export class LayerContent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.reuse = 0;
        this.preRenderContent(props);
    }
    componentDidMount() {
        this.updateDom();
    }
    UNSAFE_componentWillReceiveProps() {
        // when this component is reused and a different layer is rendered, the DOM
        // isn't cleared. For React layer contents this is not a problem. If the
        // previous layer content was not rendered with React, it stays in the DOM.
        // Thus we need to change the key of the div, to force a new one to be created
        // and the DOM to be "cleared"
        this.reuse++;
    }
    UNSAFE_componentWillUpdate(nextProps) {
        this.preRenderContent(nextProps);
    }
    componentDidUpdate() {
        this.updateDom();
    }
    render() {
        return (
        // tabIndex={-1} to allow mixed mouse & keyboard users get the focus inside a layer by clicking into it
        React.createElement(StyledLayerWrapper, { key: this.reuse, ref: this.ref, tabIndex: -1 }, this.renderable && isReact(this.renderable) ? this.renderable : null));
    }
    preRenderContent(props) {
        this.renderable = props.layer.render();
    }
    updateDom() {
        const ref = ReactDOM.findDOMNode(this.ref.current);
        if (this.renderable &&
            !isReact(this.renderable) &&
            ref instanceof HTMLElement) {
            this.renderable(ref);
        }
    }
}
//# sourceMappingURL=layer-content.js.map